import { render, staticRenderFns } from "./PaymentContraEntrega.vue?vue&type=template&id=48c7c0fe"
import script from "./PaymentContraEntrega.vue?vue&type=script&lang=js"
export * from "./PaymentContraEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports